import React from 'react';

import { ReactComponent as Chevron } from 'icons/icon-chevron.svg';
import { ReactComponent as ToggleCaret } from 'icons/icon-toggle-caret.svg';
import ColorDots from 'components/styled/ColorDots/ColorDots';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';

import Span from 'components/elements/span';
import {
  ButtonWrapper,
  ButtonContent,
  Item,
  SubLabel,
  StyledListLabel,
  Placeholder,
} from './styles';
import { IHasLabel } from 'types/shared';

function getSubLabel(item: any): string | null {
  if (!item) {
    return null;
  }

  const isCount = 'change' in item;
  const isChange = 'count' in item;

  return isCount ? 'count' : isChange ? 'change' : null;
}

const AdditionalSubLabel = ({ item }: { item: any }): JSX.Element => {
  return (
    <>
      {item?.sublabel && (
        <>
          <Span mx={2} fontWeight="600">
            &middot;
          </Span>
          <span>{item?.sublabel}</span>
        </>
      )}
    </>
  );
};

interface IButtonProps {
  selectedItem: IHasLabel;
  isOpen?: boolean;
  disabled?: boolean;
  isToggleCaret?: boolean;
  isActiveGreen?: boolean;
  minHeight?: string;
  placeholder?: string;
  isRoundedDropdown?: string;
}

export const Button: React.FC<IButtonProps> = (props) => {
  const {
    selectedItem,
    isOpen,
    disabled,
    isToggleCaret,
    isActiveGreen,
    minHeight,
    placeholder,
    isRoundedDropdown,
  } = props;
  const sublabel = getSubLabel(selectedItem);
  const Icon = isToggleCaret ? ToggleCaret : Chevron;

  return (
    <ButtonWrapper
      isOpen={isOpen}
      disabled={disabled}
      isActiveGreen={isActiveGreen}
      minHeight={minHeight}
      isRoundedDropdown={isRoundedDropdown}
    >
      <ButtonContent>
        {selectedItem && selectedItem.label}{' '}
        {sublabel && !selectedItem?.withoutSubLabel && (
          <SubLabel>({sublabel})</SubLabel>
        )}
        {!selectedItem && placeholder && (
          <Placeholder>{placeholder}</Placeholder>
        )}
        <AdditionalSubLabel item={selectedItem} />
      </ButtonContent>
      <Icon
        className={
          isToggleCaret ? 'dropdown-chevron rotated' : 'dropdown-chevron'
        }
      />
    </ButtonWrapper>
  );
};

interface IListItemData extends IHasLabel {
  supportedEntityIds?: string[];
  withoutSubLabel?: boolean;
  sublabel?: string;
}

interface IListItemProps {
  item: IListItemData;
  isActive?: boolean;
  entityColorScale?: (value: string, index: number, array: string[]) => any;
}

export const ListItem: React.FC<IListItemProps> = (props) => {
  const { item, isActive, entityColorScale } = props;
  const sublabel = getSubLabel(item);
  const supportedEntityIds = item.supportedEntityIds;
  const colors: string[] | null =
    supportedEntityIds && entityColorScale
      ? supportedEntityIds.map(entityColorScale)
      : null;

  return (
    <TippyToolTip
      tooltipContent={item?.tooltipContent}
      enabled={item?.disabled}
    >
      <Item isActive={isActive} isInRow={item?.sublabel}>
        <span>
          {colors && <ColorDots colors={colors} />}
          {item.label}
        </span>
        {sublabel && !item?.withoutSubLabel && (
          <SubLabel small>{sublabel}</SubLabel>
        )}
        <AdditionalSubLabel item={item} />
      </Item>
    </TippyToolTip>
  );
};

export const ListLabel: React.FC<IHasLabel> = (props) => {
  return <StyledListLabel small>{props.label}</StyledListLabel>;
};
